// extracted by mini-css-extract-plugin
export var author = "Quote-module--author--0ef5b";
export var authorAvatar = "Quote-module--authorAvatar--908b6";
export var authorText = "Quote-module--authorText--8e9e1";
export var avatar = "Quote-module--avatar--eed0b";
export var fancyAvatar = "Quote-module--fancyAvatar--a32e2";
export var fancyQuote = "Quote-module--fancyQuote--20884";
export var innerQuoteContent = "Quote-module--innerQuoteContent--6fd49";
export var lightOnDark = "Quote-module--lightOnDark--24dc7";
export var mdContent = "Quote-module--mdContent--7d6f9";
export var mobileStyle = "Quote-module--mobileStyle--583d4";
export var quote = "Quote-module--quote--d835d";
export var quoteColor = "Quote-module--quoteColor--b97f7";
export var quoteColorAlt = "Quote-module--quoteColorAlt--9a91b";
export var quoteContent = "Quote-module--quoteContent--eb1db";
export var quoteContentWrapper = "Quote-module--quoteContentWrapper--9a0d8";
export var quoteLeftPadding = "Quote-module--quoteLeftPadding--aa120";
export var reorderFancyAvatar = "Quote-module--reorderFancyAvatar--b5e70";
export var showcaseImage = "Quote-module--showcaseImage--e896c";
export var textAlignCenter = "Quote-module--textAlignCenter--edf5e";